import { Button, Modal, notification } from "antd";
import { useDispatch, useSelector } from "react-redux";
import React, { useContext, useEffect, useRef, useState } from "react";
import CustomForm from "../CustomForm";
import { userHasLevel } from "../../../engine/AuthRoute";
import { roles, statusPrestationsValues } from "../../../utils/constants";
import { createPortal } from "react-dom";
import { modalsByContext } from "./modals";
import {
  setPropertiesPrestation,
  updateAdminPrestation,
} from "../../../pages/Prestations/Slices/Prestation.slice";
import { ModalContext } from "../../../engine/context/Modal.provider";
import { UserContext } from "../../../engine/context/User.context";
import { FiCheckCircle } from "react-icons/fi";
import { AddresseItem } from "../../container/Addresses/AddresseItem/AddresseItem";
import {
  isCheckedAddress,
  renderAdress,
  typeAddress,
} from "../../container/Addresses/AddresseItem/AddresseHelpers";
import { inputsAddresseItem } from "../../container/Addresses/AddresseItem/AddresseItemInputs";
import { newAddresse } from "../../container/Addresses/AddressesSlice/Addresses.slice";
import { addresseItemMapsInputs } from "../../container/Addresses/AddresseItem/AddresseItemMapsInputs";
import { UserOutlined } from "@ant-design/icons";
import routes from "../../../engine/routes";

export const InstitutionSelectAddress = ({ defaultOpen }) => {
  const [open, setOpen] = useState(defaultOpen);

  useEffect(() => {
    setOpen(defaultOpen);
  }, [defaultOpen]);

  const formRefAddress = useRef(null);

  const context = useContext(ModalContext);
  const { params } = context;
  const { institution, formRef } = params;
  const dispatch = useDispatch();


  const close = params => {
    setOpen(false);
    context.closeModal(modalsByContext.InstitutionSelectAddress, params);
  };
  const onSubmitForm = async data => {
    let address = formRefAddress.current._address.find(
      e => e._id === data.address,
    );

    close({ _id: data.address, data: address });
  };

  const institutionData = formRef?.current?._institution?.find(
    e => e._id === institution,
  )?.defaultLocation;
  const config = {
    key: institution + modalsByContext.InstitutionSelectAddress,
    containerStyle: { minWidth: "500px" },
    title: "Sélectionner un lieu",
    open: open,
    width: 1000,
    onOk: () => {
      formRefAddress.current.submit();
    },
    onCancel: close,
    content: (
      <>
        <CustomForm
          refForm={formRefAddress}
          dataSource={[
            {
              parentLabel: "",
              children: [
                {
                  name: "address",
                  label: "Liste des lieux d'interventions prédéfinis",
                  type: "dynamic-select",
                  multiple: false,
                  endPoint: () =>
                    `addresses?institution=${institution}&type=${typeAddress.maps}`,
                  // updateEndPoint: [change],
                  itemsCallBack: addresses => {
                    formRefAddress.current.setFieldsValue({
                      address: institutionData,
                    });
                  },
                  inputSize: "middle",
                  quoteIcon: "edit",
                  watchValuesCallback: (value, form, r) => {
                  },
                  addonBefore: <UserOutlined />,
                  quote: (
                    <>
                      <p>
                        Vous pouvez les éditer sur la page de l'institution{" "}
                      </p>
                      <a
                        target={"_blank"}
                        onClick={event => {
                          event.preventDefault(); // Prevent default link behavior

                          const path = routes.institutions(institution)
                            .locations.path;
                          window.open(path, "_blank");
                        }}
                      >
                        Editer les lieux d'intervention
                      </a>
                    </>
                  ),
                  noSorting: true,
                  itemCallback: adress => {
                    return {
                      key: adress._id,
                      label: renderAdress(
                        adress,
                        institutionData === adress._id,
                        institutionData,
                      ),
                      value: adress._id,
                    };
                  },
                  col: 24,
                },
              ],
            },
          ]}
          labelCol={24}
          handleSubmit={onSubmitForm}
          wrapperCol={24}
        />
      </>
    ),
    footer: [
      <Button key="close" onClick={close}>
        Fermer
      </Button>,
      <Button
        icon={<FiCheckCircle size={20} />}
        type="primary"
        // loading={loadingEdit}
        // disabled={loadingEdit}
        onClick={async () => {
          try {
            formRefAddress.current.submit();
          } catch (e) {
            notification.error({
              message: e.errorFields.length + " champs est nécessaire",
            });
          }
        }}
      >
        Sélectionner le lieu
      </Button>,
    ],
  };

  return (
    <>
      {createPortal(
        <Modal {...config}>{config.content}</Modal>,
        document.querySelector("#modals"),
      )}
    </>
  );
};
